module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0001.bb5b3497.png";